import { type ReactElement } from 'react';

function LogoMainIcon(): ReactElement {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
        >
            <path
                d="M15.6777 32H10.5215C4.71099 32 0 27.373 0 21.6661V8.96668C0 8.31314 0.258992 7.69878 0.729571 7.23659L7.36161 0.716562C7.83219 0.254374 8.4577 0 9.1231 0H19.0983C22.8919 0 26.4345 1.47628 29.0736 4.15742C31.7132 6.83914 33.096 10.3725 32.9671 14.107C32.8446 17.6636 31.316 20.9841 28.6637 23.4563C26.0287 25.9121 22.5756 27.2646 18.9399 27.2646H16.705V30.9905C16.705 31.548 16.2448 32 15.6771 32H15.6777ZM2.56564 8.99677V21.6661C2.56564 25.9745 6.13487 29.4801 10.5215 29.4801H14.1393V24.7447H18.9399C21.9154 24.7447 24.7412 23.638 26.8976 21.6286C29.058 19.6146 30.3032 16.9136 30.4026 14.0224C30.5078 10.9767 29.3805 8.09567 27.2288 5.90965C25.0777 3.72419 22.19 2.52046 19.0983 2.52046H9.15432L2.56622 8.99677H2.56564Z"
                fill="#0061FE"
            />
            <path
                d="M16.6598 27.2646H11.7991C8.15239 27.2646 5.18555 24.3507 5.18555 20.769V5.14319H18.445C23.2184 5.14319 27.1021 8.95766 27.1021 13.646C27.1021 18.3343 23.2184 22.1488 18.445 22.1488H16.6598V27.2646ZM7.75176 7.66308V20.7696C7.75176 22.9653 9.56413 24.7447 11.7991 24.7447H14.0942V21.8404C14.0942 20.6185 15.1024 19.6283 16.3465 19.6283H18.3675C21.7211 19.6283 24.5036 16.9983 24.5365 13.7045C24.5695 10.3789 21.824 7.66251 18.4456 7.66251H7.75234L7.75176 7.66308Z"
                fill="#0061FE"
            />
        </svg>
    );
}

export default LogoMainIcon;
